

































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import GeneralLedgerAccount from '@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccount';
import UpdateGeneralLedgerAccountRequest from '@/models/Accounting/GeneralLedgerAccounts/UpdateGeneralLedgerAccountRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'GeneralLedgerAccountEdit' })
export default class extends SaascadaVueDialog {

    @Prop({ required: true })
    generalLedgerAccount: GeneralLedgerAccount;

    dialog = false;
    request: UpdateGeneralLedgerAccountRequest = new UpdateGeneralLedgerAccountRequest(null, null);
    accountCode: string = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateGeneralLedgerAccountRequest(this.generalLedgerAccount, new Date());
            this.accountCode = `${this.generalLedgerAccount.code}`;
        }
    }

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

    get accountTypeOptions() {
        return ListUtils.generalLedgerAccountTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Convert the account code into a number in the request
            this.request.code = +this.accountCode;

            await GeneralLedgerAccountsModule.editGeneralLedgerAccount(this.request);
        }
    }

    cancel() {
        this.dialog = false;
    }

}
